'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    width: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {},

  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-divider/index.vue
// module id = 334
// module chunks = 0 1